import React from "react"
import Helmet from "react-helmet"
import "./Heritage.css"

import autoBind from "react-autobind"
import Header from "../components/Nav.js";

import Content from "../components/Content.js"

class Heritage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
      popupActive:false,
      activeGal1:0,
      activeGal2:0,
      activeGal3:0,
      activeGal4:0,
      activeGal5:0,
    };
    autoBind(this);
  }


  // componentWillMount(){

  //   setTimeout(() => {
  //     this.setState({popupActive:true,});
  //   },5000);  
  // }
  // popupClose(){
  //   this.setState({popupActive: false});
  // }




  handleClickGal1(e){
    if(e.target.src !== undefined) {
      document.getElementById("galery1").style.display = "flex";
      document.getElementById("imgFull1").src = e.target.src;
      this.setState({activeGal1: e.target.src});
      setTimeout(() => {
        document.getElementById("galery1").style.opacity = 1;
      }, 100);
    } 
  }

  handleClose1(){
    document.getElementById("galery1").style.opacity = 0;
    setTimeout(() => {
      document.getElementById("galery1").style.display = "none";
    }, 500);
  }

  handleNext1(){
    var b = document.getElementsByClassName("galery")[0];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal1){

        if(i+1 === b.getElementsByTagName("img").length){
          document.getElementById("imgFull1").src = b.getElementsByTagName("img")[0].src;
          this.setState({activeGal1: b.getElementsByTagName("img")[0].src});
        } else {
          document.getElementById("imgFull1").src = b.getElementsByTagName("img")[i+1].src;
          this.setState({activeGal1: b.getElementsByTagName("img")[i+1].src});
          break;
        }
      }
    }
  }
  handleBack1(){
    var b = document.getElementsByClassName("galery")[0];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal1){
        if(i === 0){
          document.getElementById("imgFull1").src = b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src;
          this.setState({activeGal1: b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src});
        } else {
          document.getElementById("imgFull1").src = b.getElementsByTagName("img")[i-1].src;
          this.setState({activeGal1: b.getElementsByTagName("img")[i-1].src});
        }
      }
    }
  }






  handleClickGal2(e){
    if(e.target.src !== undefined) {
      document.getElementById("galery2").style.display = "flex";
      document.getElementById("imgFull2").src = e.target.src;
      this.setState({activeGal2: e.target.src});
      setTimeout(() => {
        document.getElementById("galery2").style.opacity = 1;
      }, 100);
    } 
  }

  handleClose2(){
    document.getElementById("galery2").style.opacity = 0;
    setTimeout(() => {
      document.getElementById("galery2").style.display = "none";
    }, 500);
  }

  handleNext2(){
    var b = document.getElementsByClassName("galery")[1];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal2){

        if(i+1 === b.getElementsByTagName("img").length){
          document.getElementById("imgFull2").src = b.getElementsByTagName("img")[0].src;
          this.setState({activeGal2: b.getElementsByTagName("img")[0].src});
        } else {
          document.getElementById("imgFull2").src = b.getElementsByTagName("img")[i+1].src;
          this.setState({activeGal2: b.getElementsByTagName("img")[i+1].src});
          break;
        }
      }
    }
  }
  handleBack2(){
    var b = document.getElementsByClassName("galery")[1];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal2){
        if(i === 0){
          document.getElementById("imgFull2").src = b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src;
          this.setState({activeGal2: b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src});
        } else {
          document.getElementById("imgFull2").src = b.getElementsByTagName("img")[i-1].src;
          this.setState({activeGal2: b.getElementsByTagName("img")[i-1].src});
        }
      }
    }
  }






  handleClickGal3(e){
    if(e.target.src !== undefined) {
      document.getElementById("galery3").style.display = "flex";
      document.getElementById("imgFull3").src = e.target.src;
      this.setState({activeGal3: e.target.src});
      setTimeout(() => {
        document.getElementById("galery3").style.opacity = 1;
      }, 100);
    } 
  }

  handleClose3(){
    document.getElementById("galery3").style.opacity = 0;
    setTimeout(() => {
      document.getElementById("galery3").style.display = "none";
    }, 500);
  }

  handleNext3(){
    var b = document.getElementsByClassName("galery")[2];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal3){

        if(i+1 === b.getElementsByTagName("img").length){
          document.getElementById("imgFull3").src = b.getElementsByTagName("img")[0].src;
          this.setState({activeGal3: b.getElementsByTagName("img")[0].src});
        } else {
          document.getElementById("imgFull3").src = b.getElementsByTagName("img")[i+1].src;
          this.setState({activeGal3: b.getElementsByTagName("img")[i+1].src});
          break;
        }
      }
    }
  }
  handleBack3(){
    var b = document.getElementsByClassName("galery")[2];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal3){
        if(i === 0){
          document.getElementById("imgFull3").src = b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src;
          this.setState({activeGal3: b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src});
        } else {
          document.getElementById("imgFull3").src = b.getElementsByTagName("img")[i-1].src;
          this.setState({activeGal3: b.getElementsByTagName("img")[i-1].src});
        }
      }
    }
  }







  handleClickGal4(e){
    if(e.target.src !== undefined) {
      document.getElementById("galery12").style.display = "flex";
      document.getElementById("imgFull").src = e.target.src;
      this.setState({activeGal2: e.target.src});
      setTimeout(() => {
        document.getElementById("galery12").style.opacity = 1;
      }, 100);
    } 
  }

  handleClose4(){
    document.getElementById("galery4").style.opacity = 0;
    setTimeout(() => {
      document.getElementById("galery4").style.display = "none";
    }, 500);
  }

  handleNext4(){
    var b = document.getElementsByClassName("galery")[3];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal4){

        if(i+1 === b.getElementsByTagName("img").length){
          document.getElementById("imgFull4").src = b.getElementsByTagName("img")[0].src;
          this.setState({activeGal4: b.getElementsByTagName("img")[0].src});
        } else {
          document.getElementById("imgFull4").src = b.getElementsByTagName("img")[i+1].src;
          this.setState({activeGal4: b.getElementsByTagName("img")[i+1].src});
          break;
        }
      }
    }
  }
  handleBack4(){
    var b = document.getElementsByClassName("galery")[3];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal4){
        if(i === 0){
          document.getElementById("imgFull4").src = b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src;
          this.setState({activeGal4: b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src});
        } else {
          document.getElementById("imgFull4").src = b.getElementsByTagName("img")[i-1].src;
          this.setState({activeGal4: b.getElementsByTagName("img")[i-1].src});
        }
      }
    }
  }








  handleClickGal5(e){
    if(e.target.src !== undefined) {
      document.getElementById("galery5").style.display = "flex";
      document.getElementById("imgFull").src = e.target.src;
      this.setState({activeGal5: e.target.src});
      setTimeout(() => {
        document.getElementById("galery5").style.opacity = 1;
      }, 100);
    } 
  }

  handleClose5(){
    document.getElementById("galery5").style.opacity = 0;
    setTimeout(() => {
      document.getElementById("galery5").style.display = "none";
    }, 500);
  }

  handleNext5(){
    var b = document.getElementsByClassName("galery")[4];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal5){

        if(i+1 === b.getElementsByTagName("img").length){
          document.getElementById("imgFull5").src = b.getElementsByTagName("img")[0].src;
          this.setState({activeGal5: b.getElementsByTagName("img")[0].src});
        } else {
          document.getElementById("imgFull5").src = b.getElementsByTagName("img")[i+1].src;
          this.setState({activeGal5: b.getElementsByTagName("img")[i+1].src});
          break;
        }
      }
    }
  }
  handleBack5(){
    var b = document.getElementsByClassName("galery")[4];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal5){
        if(i === 0){
          document.getElementById("imgFull").src = b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src;
          this.setState({activeGal2: b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src});
        } else {
          document.getElementById("imgFull").src = b.getElementsByTagName("img")[i-1].src;
          this.setState({activeGal2: b.getElementsByTagName("img")[i-1].src});
        }
      }
    }
  }








  escFunction(event){
    if(event.keyCode === 37) {
      this.handleBack1();
      this.handleBack2();
      this.handleBack3();
      this.handleBack4();
      this.handleBack5();
    } else if(event.keyCode === 39 || event.keyCode === 32) {
      this.handleNext1();
      this.handleNext2();
      this.handleNext3();
      this.handleNext4();
      this.handleNext5();
    } else if(event.keyCode === 27) {
      this.handleClose1();
      this.handleClose2();
      this.handleClose3();
      this.handleClose4();
      this.handleClose5();
    }
  }
  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render(){
  const { title1, aljosa, title2, sectionFounder, section19792004, section20042012, section20122015, section2015PRESENT, sectionNEARFUTURE, galery} = this.props.page
  return (
    <div className="Heritage">
      <Helmet>
        <title>{title2}</title>
      </Helmet>

      <Header />
      <div className="heritageTitle">{title1}</div>
      <div className="sectionHeritageAljosa">
        <div className="containerHeritageAljosa">
          <img alt="" className="aljosaPicture" src={aljosa} />
        </div>
      </div>
      <div className="sectionHeritage">
        <div className="containerHeritage">
          <Content source={sectionFounder} />
        </div>
      </div>
      <div className="heritageTitle">{title2}</div>
      <div className="sectionHeritage">
        <div className="containerHeritage">
          <Content source={section19792004} />
        </div>
      </div>
      <div className="sectionHeritageGallery">
        <div onClick={this.handleClickGal1} className="containerHeritage galery">
          <Content source={this.props.page.galery1} />
        </div>
      </div>
      <div className="sectionHeritage">
        <div className="containerHeritage">
          <Content source={section20042012} />
        </div>
      </div>
      <div className="sectionHeritageGallery">
        <div onClick={this.handleClickGal2} className="containerHeritage galery">
          <Content source={this.props.page.galery2} />
        </div>
      </div>
      <div className="sectionHeritage">
        <div className="containerHeritage">
          <Content source={section20122015} />
        </div>
      </div>
      <div className="sectionHeritageGallery">
        <div onClick={this.handleClickGal3} className="containerHeritage galery">
          <Content source={this.props.page.galery3} />
        </div>
      </div>
      <div className="sectionHeritage">
        <div className="containerHeritage">
          <Content source={section2015PRESENT} />
        </div>
      </div>
      <div className="sectionHeritageGallery">
        <div onClick={this.handleClickGal4} className="containerHeritage galery">
          <Content source={this.props.page.galery4} />
        </div>
      </div>
      <div className="sectionHeritage">
        <div className="containerHeritage">
          <Content source={sectionNEARFUTURE} />
        </div>
      </div>
      <div className="sectionHeritageGallery">
        <div onClick={this.handleClickGal5} className="containerHeritage galery">
          <Content source={this.props.page.galery5} />
        </div>
      </div>
      <div id="galery1" className="sectionHeritageGalleryFixed">
        <div onClick={this.handleClose1} className="HeritageLayer"></div>
        <img alt="back arrow" onClick={this.handleBack1} id="imgFullw" className="arrowBack" src="assets/icons/arrowBack.png" />
        <img alt="close" onClick={this.handleClose1} className="closeButton" src="assets/icons/closeButton.png" />
        <img alt="" id="imgFull1" className="imgFull" src="" />
        <img alt="back next" onClick={this.handleNext1} id="imgFullwe" className="arrowNext" src="assets/icons/arrowNext.png" />
      </div>
      <div id="galery2" className="sectionHeritageGalleryFixed">
        <div onClick={this.handleClose2} className="HeritageLayer"></div>
        <img alt="back arrow" onClick={this.handleBack2} id="imgFullw" className="arrowBack" src="assets/icons/arrowBack.png" />
        <img alt="close" onClick={this.handleClose2} className="closeButton" src="assets/icons/closeButton.png" />
        <img alt="" id="imgFull2" className="imgFull" src="" />
        <img alt="back next" onClick={this.handleNext2} id="imgFullwe" className="arrowNext" src="assets/icons/arrowNext.png" />
      </div>
      <div id="galery3" className="sectionHeritageGalleryFixed">
        <div onClick={this.handleClose3} className="HeritageLayer"></div>
        <img alt="back arrow" onClick={this.handleBack3} id="imgFullw" className="arrowBack" src="assets/icons/arrowBack.png" />
        <img alt="close" onClick={this.handleClose3} className="closeButton" src="assets/icons/closeButton.png" />
        <img alt="" id="imgFull3" className="imgFull" src="" />
        <img alt="back next" onClick={this.handleNext3} id="imgFullwe" className="arrowNext" src="assets/icons/arrowNext.png" />
      </div>
      <div id="galery4" className="sectionHeritageGalleryFixed">
        <div onClick={this.handleClose4} className="HeritageLayer"></div>
        <img alt="back arrow" onClick={this.handleBack4} id="imgFullw" className="arrowBack" src="assets/icons/arrowBack.png" />
        <img alt="close" onClick={this.handleClose4} className="closeButton" src="assets/icons/closeButton.png" />
        <img alt="" id="imgFull4" className="imgFull" src="" />
        <img alt="back next" onClick={this.handleNext4} id="imgFullwe" className="arrowNext" src="assets/icons/arrowNext.png" />
      </div>
      <div id="galery5" className="sectionHeritageGalleryFixed">
        <div onClick={this.handleClose5} className="HeritageLayer"></div>
        <img alt="back arrow" onClick={this.handleBack5} id="imgFullw" className="arrowBack" src="assets/icons/arrowBack.png" />
        <img alt="close" onClick={this.handleClose5} className="closeButton" src="assets/icons/closeButton.png" />
        <img alt="" id="imgFull5" className="imgFull" src="" />
        <img alt="back next" onClick={this.handleNext5} id="imgFullwe" className="arrowNext" src="assets/icons/arrowNext.png" />
      </div>
    </div>
  )
}}

export default Heritage;



// WEBPACK FOOTER //
// ./src/views/Heritage.js